import Link from "next/link";
import Image from "next/image";
import { storyblokEditable, StoryblokComponent } from "@storyblok/react/rsc";
import { renderRichText } from "@storyblok/react";

import { Button } from "@/components/ui/button";
import { RichText } from "@/components/typography/RichText";
import type { TopicSummaryCardStoryblok } from "@/component-types-sb";
import { getUrlFromLinkObject } from "@/lib/storyblok/utils";

type TopicSummaryCardProps = {
  blok: TopicSummaryCardStoryblok;
};

const TopicSummaryCard = ({ blok }: TopicSummaryCardProps) => {
  const href = getUrlFromLinkObject(blok.button_link) || undefined;

  return (
    <article
      {...storyblokEditable(blok)}
      className="w-[345px] md:w-[600px] bg-white rounded-2xl overflow-hidden flex flex-col justify-between h-full"
    >
      {blok.image?.filename && (
        <div className="relative w-full h-[160px] md:h-[220px]">
          <Image
            src={blok.image.filename}
            alt={blok.image.alt || blok.title || ""}
            fill
            sizes="(min-width: 768px) 600px, 345px"
            className="object-cover"
          />
        </div>
      )}
      <div className="flex flex-col gap-4 p-3 flex-1 justify-between">
        <div className="flex flex-col gap-4">
          <div className="flex flex-col">
            <h3 className="text-headline-md">{blok.title}</h3>
            {blok.description && (
              <RichText html={renderRichText(blok.description)} />
            )}
          </div>

          {blok.list_items && blok.list_items.length > 0 && (
            <div className="flex flex-col gap-[9px]">
              {blok.list_items.map((item) => (
                <StoryblokComponent blok={item} key={item._uid} />
              ))}
            </div>
          )}
        </div>

        {href ? (
          <Button variant="black" className="w-full mt-4" asChild>
            <Link href={href}>
              {blok.button_label || "Weiterlesen"}
            </Link>
          </Button>
        ) : (
          <Button variant="black" className="w-full mt-4" disabled>
            {blok.button_label || "Weiterlesen"}
          </Button>
        )}
      </div>
    </article>
  );
};

export default TopicSummaryCard;
